/*  Shared  */
import Logs from 'application/Shared/Pages/Logs/Logs';

/*  React  */
import React from 'react';

export const AppLogs = ({ applicationId }) => (
    <Logs applicationId={applicationId} subPage subPagePaper />
);
